import Vue from 'vue'
import Vuex from 'vuex'
import { homeModule } from './modules/home'
import getCookie from '@/utils/getCookies'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        theme: getCookie('THEME_ID') || ''
    },
    // mutations: {
    //     SET_THEME_CONFIG (state, theme = '') {
    //         state.theme = theme
    //     }
    // },
    // actions: {
    //     GET_THEME_CONFIG ({ commit }) {
    //         $jsBridge.call('web_getYxmThemeConfig', {}, res => {
    //             commit('SET_THEME_CONFIG', res)
    //         })
    //     }
    // },
    modules: {
        [homeModule.name]: homeModule
    }
})
